export default "__VITE_ASSET__P_6EQ7pq__"